import { Table } from '@fareye/ui'
import React from 'react'
import { getTableColumns } from '../Columns'
import { useTranslation } from '@fareye/common'

const COLUMNS = [
  {
    label: 'IMEI',
    key: 'imei'
  },
   {
    label: 'GSM PHONE NUMBER',
    key: 'gsmPhoneNumber'
  },
  {
    label: 'Vehicle No',
    key: 'vehicleNo'
  },
  {
    label: 'First Mapped Date',
    key: 'firstMappedDate',
    formatter: 'dateFormatterTz'
  },
  {
    label: 'Transporter Name',
    key: 'transporterName'
  },
  {
    label: 'Material',
    key: 'material'
  },
  {
    label: 'Status',
    key: 'status'
  },
  {
    label: 'CREATED AT',
    key: 'createdAt',
    formatter: 'dateFormatterTz'
  },
  {
    label: 'UPDATED AT',
    key: 'updatedAt',
    formatter: 'dateFormatterTz'
  },
   {
    label: 'Trip Status',
    key: 'tripStatus'
  },
  {
    label: 'Scraped Status',
    key: 'isScraped'
  },
  {
    label: 'Scraped Reason',
    key: 'scrapedReason'
  },
  {
    label: 'Actions',
    key: 'action'
  }
]

export default function GpsDeviceTable({
  deviceData: { data, meta, isLoading },
  setSelectedDevice,
  hideAction = false,
  setDevices,
  meta: metaInfo,
  setMeta,
}: any) {
  const { t } = useTranslation()
  const hideKeys = hideAction
  ? ['action', 'tripStatus','material', 'firstMappedDate','isScraped','scrapedReason','transporterName','status','createdAt']
  : ['phoneNumber']
  //const selectedColumns = COLUMNS.filter(ele => !hideKeys.includes(ele.key))
  const selectedColumns = COLUMNS
  .filter(ele => !hideKeys.includes(ele.key))
  .map(col => {
    if (hideAction && col.key === 'gsmPhoneNumber') {
      return { ...col, key: 'phoneNumber' }
    }
    return col
  })
  return (
    <Table
      className="striped responsive"
      columns={getTableColumns(selectedColumns, {
        t,
        setSelectedDevice,
        hideAction,
        setDevices
      })}
      data={data}
      size="xs"
      showTotalCount={false}
      sortable
      dataLoading={isLoading}
      totalElements={metaInfo.count}
      disablePageSizeChange
      defaultPageIndex={metaInfo.page - 1}
      defaultPageSizeOptions={[metaInfo.perPage]}
      onPageChange={(pageIndex: number) => {
        setMeta({ ...metaInfo, page: pageIndex + 1 })
      }}
    />
  )
}
